import './page-footer-nav.less';
import React from 'react';
import {DatePicker, Input, Pagination} from 'antd';
import moment from 'moment';

const { Search } = Input;
const { RangePicker } = DatePicker;

export class PageFooterNav extends React.Component {
  render() {
    let { page, pageSize, total, onChangePagination, filters, patchFilters, applyFilters, filtersEnabled } = this.props;

    const dateRange = filters.date ? [moment(filters.date[0]), moment(filters.date[1])] : null;

    if (!filtersEnabled) {
      filtersEnabled = ['phone', 'date'];
    }

    return (
      <div className="footer-nav">
        <Pagination
          showSizeChanger
          defaultPageSize={pageSize}
          defaultCurrent={page}
          total={total}

          pageSizeOptions={['10', '50', '100', '500', '1000']}
          onShowSizeChange={onChangePagination}
          onChange={onChangePagination}
        />

        {filtersEnabled.includes('phone') && (
          <div className="right">
            <Search
              value={filters.phone}
              placeholder="Поиск по номеру телефона"
              onSearch={() => applyFilters()}
              onChange={(e) => patchFilters({ phone: e.target.value })}
            />
          </div>
        )}
        {filtersEnabled.includes('date') && (
          <div className="right">
            <RangePicker
              dropdownClassName={'footer-nav-daterange'}
              value={dateRange}
              onChange={this.onChangeRangePicker}
              suffixIcon />
          </div>
        )}
      </div>
    );
  }

  onChangeRangePicker = (value, valueStrings) => {
    if (!valueStrings || valueStrings.every(i => i === '')) {
      valueStrings = null;
    }

    this.props.patchFilters({ date: valueStrings });
    this.props.applyFilters();
  }
}




// WEBPACK FOOTER //
// ./src/components/pages/crm/common/page-footer-nav.js